/**
 * Quotify bridge — correct variant on collection grids and open quote when widget is not ready yet.
 */
(function () {
  const QUOTIFY_SELECTOR = '[data-quotify]';
  let widgetReadyPromise = null;

  function syncQuotifyButton(button) {
    const form = button.closest('form[data-product-form], form[action*="/cart/add"]');
    const idField = form?.querySelector('input[name="id"], select[name="id"]');
    const variantId = idField?.value || button.getAttribute('data-variant');
    if (variantId) button.setAttribute('data-variant', variantId);
  }

  function syncAllQuotifyButtons(root) {
    (root || document).querySelectorAll(QUOTIFY_SELECTOR).forEach(syncQuotifyButton);
  }

  function unlockQuotifyScripts() {
    document.querySelectorAll('script').forEach(function (script) {
      const src = (script.src || script.getAttribute('data-src') || '').toLowerCase();
      if (src.indexOf('quotify') === -1) return;
      const deferredSrc = script.getAttribute('data-src');
      if (deferredSrc && !script.getAttribute('src')) {
        script.src = deferredSrc;
        script.removeAttribute('data-src');
      }
      if (script.type === 'text/lazyload' || script.type === 'lightJs') {
        script.type = 'text/javascript';
      }
    });
  }

  function getWidgetUrl() {
    if (window.QUOTIFY_WIDGET_URL) return window.QUOTIFY_WIDGET_URL;
    if (window.Shopify && Shopify.shop) {
      return 'https://quotify.dev/js/widget.js?shop=' + Shopify.shop;
    }
    return null;
  }

  function ensureQuotifyWidget() {
    if (typeof window.quotifyProduct === 'function') {
      return Promise.resolve();
    }

    if (!widgetReadyPromise) {
      widgetReadyPromise = new Promise(function (resolve, reject) {
        unlockQuotifyScripts();

        const url = getWidgetUrl();
        if (url && !document.querySelector('script[src*="quotify.dev/js/widget"]')) {
          const script = document.createElement('script');
          script.src = url;
          script.async = true;
          document.head.appendChild(script);
        }

        const deadline = Date.now() + 3000;
        (function waitForWidget() {
          unlockQuotifyScripts();
          if (typeof window.quotifyProduct === 'function') {
            resolve();
            return;
          }
          if (Date.now() >= deadline) {
            reject(new Error('Quotify widget did not load'));
            return;
          }
          setTimeout(waitForWidget, 50);
        })();
      }).catch(function () {
        widgetReadyPromise = null;
      });
    }

    return widgetReadyPromise;
  }

  function withQuotifyVariantContext(button, callback) {
    const variantId = button.getAttribute('data-variant');
    let tempForm = null;

    if (variantId) {
      tempForm = document.createElement('form');
      tempForm.action = '/cart/add';
      tempForm.style.display = 'none';
      const variantInput = document.createElement('input');
      variantInput.type = 'hidden';
      variantInput.name = 'id';
      variantInput.value = variantId;
      tempForm.appendChild(variantInput);
      document.body.insertBefore(tempForm, document.body.firstChild);
    }

    try {
      callback();
    } finally {
      if (tempForm) tempForm.remove();
    }
  }

  function openQuotifyQuote(button) {
    syncQuotifyButton(button);
    return ensureQuotifyWidget().then(function () {
      withQuotifyVariantContext(button, function () {
        window.quotifyProduct({
          type: 'click',
          target: button,
          currentTarget: button,
          which: 1,
          button: 0,
          preventDefault: function () {},
          stopPropagation: function () {},
          stopImmediatePropagation: function () {},
        });
      });
    });
  }

  function shouldHandleQuotifyClick() {
    return (
      document.querySelectorAll('form[action*="/cart/add"]').length > 1 ||
      typeof window.quotifyProduct !== 'function'
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(QUOTIFY_SELECTOR);
      if (!button) return;

      syncQuotifyButton(button);

      if (!shouldHandleQuotifyClick()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openQuotifyQuote(button).catch(function () {});
    },
    true
  );

  document.addEventListener('change', function (event) {
    const form = event.target.closest?.('form');
    if (!form) return;
    if (event.target.matches('[name="id"], input[type="radio"]')) {
      form.querySelectorAll(QUOTIFY_SELECTOR).forEach(syncQuotifyButton);
    }
  });

  window.reScanQuotifyButtons = syncAllQuotifyButtons;

  const previousReExecuteOpener = window.reExecuteOpener;
  if (typeof previousReExecuteOpener === 'function') {
    window.reExecuteOpener = function () {
      previousReExecuteOpener.apply(this, arguments);
      syncAllQuotifyButtons();
    };
  }

  function initQuotifyBridge() {
    syncAllQuotifyButtons();
    ensureQuotifyWidget().catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', initQuotifyBridge);
  document.addEventListener('asyncLazyLoad', function () {
    unlockQuotifyScripts();
    syncAllQuotifyButtons();
  });

  if (document.readyState !== 'loading') {
    initQuotifyBridge();
  }
})();
